import { Image } from "../image";
import { cn } from "../utils/cn";
import { getFirstChar } from "./utils";

interface Props {
  imageUrl?: string;
  alt: string;
  className?: string;
  fallback?: boolean;
  fallbackClassName?: string;
  borderColor?: string;
  active: boolean;
}

const defaultClassName = "w-full h-full rounded-xl";

export const HomeAvatar = ({
  imageUrl,
  alt,
  className,
  fallback = true,
  fallbackClassName,
  borderColor,
  active,
}: Props) => {
  return (
    <div
      className={cn(
        defaultClassName,
        className,
        "relative overflow-hidden p-4",
      )}
      style={{ borderColor: borderColor }}
    >
      {imageUrl || !fallback ? (
        <Image
          src={imageUrl}
          alt={alt}
          className={cn(
            "absolute inset-0 w-full h-full p-2",
            !active && "bg-transparent",
          )}
        />
      ) : (
        <div
          className={cn(
            "absolute inset-0 w-full h-full bg-gradient-to-tr from-red-2 to-red-3 flex items-center justify-center",
          )}
        >
          <span
            className={cn("text-white text-2xl font-black", fallbackClassName)}
          >
            {getFirstChar(alt)}
          </span>
        </div>
      )}
    </div>
  );
};

HomeAvatar.displayName = "HomeAvatar";
